<template>
    <div class="mql-form-title">
        <div class="title">
            {{title}}
        </div>
        <el-row><slot></slot></el-row>
    </div>
</template>

<script>

export default {
    name: 'MqlFormTitle',
    props: {
        title: String
    },
    data () {
        return {

        }
    },
    mounted () {
    },
    methods: {
    }
}
</script>

<style lang='scss' scoped>
    .mql-form-title{
        .title{
            border-left: 5px solid #ddd;
            padding-left: 10px;
            color: #333;
            margin-bottom: 20px;
            margin-left: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/core/MqlLayout/MqlFormTitle/index.vue